<template>
  <b-form-group
    label="Menşei"
    label-for="id_origins"
  >
    <validation-provider
      #default="{ errors }"
      name="Menşei"
      rules="required"
    >
      <v-select
        v-model="dataItem.id_origins"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Menşei"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'ProductsDepartmentSelect',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['origins/dataList']
    },
    dataItem() {
      return this.$store.getters['products/dataItem']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('origins/getDataList')
    },
  },
}
</script>
